module.exports = __webpack_public_path__ + "html/block-options.component.html";